import { FrameTarget } from '@studiometa/ui';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

/**
 *
 */
export default class PageTransition extends FrameTarget {
  static config = {
    ...FrameTarget.config,
    name: 'FrameTarget',
  };

  /**
   * @returns {HTMLElement|undefined}
   */
  get scrim() {
    return document.querySelector('[data-ref="scrim"]');
  }

  /**
   * Transition :
   * 1. Scale down ancien contenu + scrim
   * 2. Nouveau contenu arrive par-dessus avec clip-path circle qui s'ouvre
   * 3. Intros lancées à 80% du clip-path
   * @param {Element|null} content
   * @returns {Promise<void>}
   */
  async updateContent(content) {
    if (!content) return;

    const scrollY = window.scrollY;

    // Bloquer les intros pendant la transition
    window.__pageTransitioning = true;

    // 1. Déplacer les éléments fixed hors de l'ancien contenu
    const fixedEls = [...this.$el.querySelectorAll('.fixed')];
    fixedEls.forEach((el) => document.body.append(el));

    // 2. Capturer l'ancien contenu dans un wrapper fixed
    const oldWrapper = document.createElement('div');
    Object.assign(oldWrapper.style, {
      position: 'fixed',
      inset: '0',
      zIndex: '1',
      overflow: 'hidden',
      background: 'black',
    });

    const oldInner = document.createElement('div');
    oldInner.style.transform = `translateY(${-scrollY}px)`;

    while (this.$el.firstChild) {
      oldInner.append(this.$el.firstChild);
    }
    oldWrapper.append(oldInner);
    document.body.append(oldWrapper);

    // 3. Insérer le nouveau contenu dans un wrapper par-dessus
    const newWrapper = document.createElement('div');
    Object.assign(newWrapper.style, {
      position: 'fixed',
      inset: '0',
      zIndex: '2',
      background: '#000',
      clipPath: 'inset(100% 0% 0% 0%)',
    });

    const newInner = document.createElement('div');
    newInner.append(...Array.from(content.childNodes));
    newWrapper.append(newInner);
    document.body.append(newWrapper);

    // console.log(newWrapper);
    // return;

    // 4. Animation : clip-path ouvre le nouveau contenu par-dessus l'ancien
    let introDispatched = false;

    await new Promise((resolve) => {
      gsap.to(newWrapper, {
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: 0.6,
        ease: 'power3.inOut',
        onUpdate() {
          if (this.progress() >= 0.8 && !introDispatched) {
            introDispatched = true;
            window.__pageTransitioning = false;
            document.dispatchEvent(new CustomEvent('page:enter'));
          }
        },
        onComplete: resolve,
      });
    });

    // 5. Déplacer le nouveau contenu dans <main>
    this.$el.append(...Array.from(newInner.childNodes));
    window.scrollTo({ top: 0, behavior: 'instant' });

    // 6. Nettoyage
    oldWrapper.remove();
    newWrapper.remove();
    fixedEls.forEach((el) => el.remove());
    // gsap.set(this.scrim, { clearProps: 'all' });

    requestAnimationFrame(() => ScrollTrigger.refresh());
  }

  /** @returns {Promise<void>} */
  async leave() {}

  /** @returns {Promise<void>} */
  async enter() {}
}
